import {FC} from 'react'
import {Link} from 'react-router-dom'
import {SubmitHandler, useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import Button from 'jbc-front/components/Button'
import {Label} from 'jbc-front/components/presenters/form/Label'
import {Textarea} from 'jbc-front/components/presenters/form/Textarea'
import {ErrorMessage} from 'jbc-front/components/presenters/form/ErrorMessage'
import {Spacer} from 'jbc-front/components/presenters/Spacer'
import {EmployeeName} from '../../parts/EmployeeName'
import {Employee} from './query'
import {Schema, schema} from './schema'
import styles from './Presenter.scss'

interface PresenterParams {
  employee: Employee
  onSubmit: SubmitHandler<Schema>
  onSkip: SubmitHandler<Schema>
}

export const Presenter: FC<PresenterParams> = ({employee, onSubmit, onSkip}) => {
  const {
    register,
    handleSubmit,
    formState: {isSubmitting, errors},
  } = useForm<Schema>({
    defaultValues: {
      message: '',
    },
    resolver: yupResolver(schema),
  })

  return (
    <div>
      <div className="l-title-wrap">
        <h1 className="m-title-main">以下の情報を従業員に入力依頼できます</h1>
        <EmployeeName employee={employee} />
      </div>
      <div className="l-wrap-s">
        <div className={styles.box}>
          <ul className={styles.list}>
            <li>
              健康保険・厚生年金保険 育児休業等取得者申出書（新規・延長）／終了届
              <ul className={styles.subList}>
                <li>養育する子の氏名</li>
                <li>養育する子の生年月日</li>
                <li>区分</li>
                <li>養育開始年月日（実子以外）</li>
                <li>育児休業等開始年月日</li>
                <li>育児休業等終了（予定）年月日</li>
                <li>育児休業等取得日数</li>
                <li>就業日数</li>
                <li>パパママ育休プラス該当区分</li>
                <li>備考</li>
                <li>育休等取得内訳</li>
              </ul>
            </li>
            <li>
              育児休業給付受給資格確認票・（初回）育児休業給付金／出生後休業支援給付金支給申請書
              <ul className={styles.subList}>
                <li>育児休業等開始年月日</li>
                <li>出産年月日</li>
                <li>過去に同一の子について出生時育児休業または育児休業取得の有無</li>
                <li>出産予定日</li>
                <li>職場復帰年月日</li>
                <li>支給対象となる期間の延長事由ー期間</li>
                <li>パパ・ママ育休プラス制度活用</li>
                <li>育児休業再取得理由</li>
                <li className={styles.listSubHeader}>（出生後休業支援給付金の支給申請を行う場合）</li>
                <li>支給理由</li>
                <li>配偶者の被保険者番号</li>
                <li>配偶者の育児休業開始年月日</li>
                <li>配偶者の被保険者番号</li>
                <li>配偶者の育児休業開始年月日</li>
                <li className={styles.listSubHeader}>（払渡希望金融機関指定届）</li>
                <li className={styles.listSubHeader}>（ゆうちょ銀行以外）</li>
                <li>銀行コード</li>
                <li>銀行名</li>
                <li>支店コード</li>
                <li>支店名</li>
                <li>本店支店区分</li>
                <li>口座番号</li>
                <li className={styles.listSubHeader}>（ゆうちょ銀行）</li>
                <li>記号・番号</li>
              </ul>
            </li>
          </ul>
        </div>

        <div className={styles.formWrap}>
          <Label>メッセージ</Label>
          <Spacer direction="y" size={10} />
          <Textarea
            {...register('message')}
            isError={!!errors.message?.message}
            placeholder="入力したメッセージは送信メールに反映されます"
          />
          {errors.message?.message && <ErrorMessage>{errors.message.message}</ErrorMessage>}
          <Spacer direction="y" size={20} />

          <div className={styles.buttonWrap}>
            <Button onClick={handleSubmit(onSkip)} disabled={isSubmitting}>
              スキップ
            </Button>
            <div className={styles.buttonNoteWrap}>
              <Button
                primary
                onClick={handleSubmit(onSubmit)}
                disabled={isSubmitting || !employee.user || !employee.user.email}
                className="u-ml20"
              >
                上記の入力依頼を送信
              </Button>
              {(!employee.user || !employee.user.email) && (
                <div className={styles.noteWrap}>
                  <div className={styles.note}>
                    <p>
                      従業員に手続きの入力依頼をする場合、あらかじめ従業員招待をしてマイページを発行してください。従業員招待は
                      <Link to="/employees/invite">こちら</Link>
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
